module.exports = __webpack_public_path__ + "static/media/house2lg.a0a064b8.png";